import React, {useEffect, useState} from 'react';
import {Table, Tag} from "antd";
import {useDispatch, useSelector} from "react-redux";

import {getHistoryBalanceCustomer} from "../../appRedux/actions/Balance";
import {SearchTable} from "../../util/SearchTable";
import IntlMessages from "../../util/IntlMessages";

const TableTabBalanceCustomer = ({stateTab}) => {

    const dispatch = useDispatch()
    const {historyBalanceCustomer} = useSelector(({historyBalance}) => historyBalance)
    const {pageSize} = useSelector(({settings}) => settings);
    const [pagination, setPagination] = useState({page: 1, page_size: pageSize})

    const {getColumnSearchProps} = SearchTable()

    useEffect(() => {
        if (stateTab === 'tab1') {
            dispatch(getHistoryBalanceCustomer(pagination))
        }
    }, [stateTab, pagination])

    let column = [
        {
            title: <><IntlMessages id="balance.balanceApp.date"/></>,
            dataIndex: 'date',
            key: 'date',
            render: text => (
                <span>
                    {new Date(+text).toLocaleString().replace(',', "")}
                </span>
            )
        },
        {
            title: <><IntlMessages id="balance.balanceApp.action"/></>,
            dataIndex: 'action',
            key: 'action',
            render: text => (
                <>
                    {
                        text ?
                            <Tag color={'green'}>
                                {<IntlMessages id="balance.balanceApp.coming"/>}
                            </Tag>
                            :
                            <Tag color={'red'}>
                                {<IntlMessages id="balance.balanceApp.spending"/>}
                            </Tag>
                    }
                </>
            )
        },
        {
            title: <><IntlMessages id="balance.balanceApp.amount"/></>,
            dataIndex: 'amount',
            key: 'amount',
        },
        {
            title: <><IntlMessages id="balance.balanceApp.balance"/></>,
            dataIndex: 'balance',
            key: 'balance',
        },
        {
            title: <><IntlMessages id="balance.balanceApp.description"/></>,
            dataIndex: 'description',
            key: 'description',
            ...getColumnSearchProps('description'),
        }
    ]

    const onChange = ({current, pageSize}, filters) => {
        const pureFilters = Object.fromEntries(Object.entries(({search: filters.description}))
            .filter(([_, v]) => v != null));
        setPagination(Object.assign({page: current, page_size: pageSize}, pureFilters))
    }

    return (
        <Table
            rowKey="id"
            dataSource={historyBalanceCustomer.results}
            className="gx-table-responsive"
            columns={column}
            size={'small'}
            onChange={onChange}
            pagination={{
                showSizeChanger: true,
                defaultPageSize: pagination.page_size,
                total: historyBalanceCustomer.count
            }}
        />
    );
};

export default TableTabBalanceCustomer;